import { cn } from '@/lib/utils'
import type { Dictionary } from '@/types'

interface RevenueStatProps {
  label: string
  value: string
  trend: string
  trendType?: 'positive' | 'negative'
}

interface PaymentRevenueCardProps {
  revenueToday: Dictionary
  revenueThisWeek: Dictionary
  loading?: boolean
}

function RevenueStat({
  label,
  value,
  trend,
  trendType = 'positive',
}: RevenueStatProps) {
  return (
    <div className='flex-1'>
      <p className='text-[#A3A3A3] text-sm mb-1'>{label}</p>
      <h2 className='SFProMedium text-[1.3rem] text-[#000000] font-bold mb-1'>
        {value}
      </h2>
      <p
        className={cn(
          'text-sm',
          trendType === 'positive' ? 'text-green-600' : 'text-red-500'
        )}
      >
        {trend}
      </p>
    </div>
  )
}

export default function PaymentRevenueCard({
  revenueToday,
  revenueThisWeek,
  loading = false,
}: PaymentRevenueCardProps) {
  console.log(revenueToday, revenueThisWeek)
  const todayValue =
    revenueToday !== undefined ? revenueToday?.formatted : '£0.00'
  const weekValue =
    revenueThisWeek !== undefined ? revenueThisWeek?.formatted : '£0.00'
  if (loading) {
    return (
      <div className='bg-white rounded-[1.15rem] p-5 h-full'>
        <div className='h-6 w-40 bg-gray-100 rounded animate-pulse mb-4' />
        <div className='flex gap-6'>
          <div className='flex-1 space-y-2'>
            <div className='h-4 w-24 bg-gray-100 rounded animate-pulse' />
            <div className='h-8 w-20 bg-gray-100 rounded animate-pulse' />
            <div className='h-4 w-28 bg-gray-100 rounded animate-pulse' />
          </div>
          <div className='w-px bg-gray-200' />
          <div className='flex-1 space-y-2'>
            <div className='h-4 w-28 bg-gray-100 rounded animate-pulse' />
            <div className='h-8 w-24 bg-gray-100 rounded animate-pulse' />
            <div className='h-4 w-24 bg-gray-100 rounded animate-pulse' />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='bg-white rounded-[1.15rem] p-5 h-full'>
      <h3 className='text-[1.1rem] SFPro-Semibold font-bold tracking-wider mb-4'>
        Payment Revenue
      </h3>
      <div className='flex gap-6'>
        <RevenueStat
          label='Revenue Today'
          value={todayValue}
          trend={revenueToday?.change_description}
          trendType={revenueToday?.change_type}
        />
        <div className='w-px bg-gray-200 mr-6' />
        <RevenueStat
          label='Revenue This Week'
          value={weekValue}
          trend={revenueThisWeek?.change_description}
          trendType={revenueThisWeek?.change_type}
        />
      </div>
    </div>
  )
}
